import { scrollTo } from "@/scripts/common/scroll-to";
import { fireEvent } from "@/scripts/common/util";
import ajax from "@/scripts/common/ajax";
import delegate from "delegate-it";

const selectors = {
  paginatedListControls: "[data-paginated-list-controls]",
  paginatedListTrigger: "[data-paginated-list-trigger]",
  paginatedListHide: "data-paginated-list-hide",
  paginatedListRoot: "[data-paginated-list-root]",
  paginatedListScrollTo: "[data-paginated-list-scroll-to]",
  paginatedList: "[data-paginated-list]",
};

const handleTrigger = async (e) => {
  const target = e.target.closest(selectors.paginatedListTrigger);
  const controls = target.closest(selectors.paginatedListControls);
  const list =
    target.closest(selectors.paginatedListRoot)?.querySelector(selectors.paginatedList) ??
    document.querySelector(selectors.paginatedList);

  e.preventDefault();

  controls.classList.add("pointer-events-none", "opacity-60");

  const res = await ajax.get(target.href).json();

  const updatedControls = document.createRange().createContextualFragment(res.pagination);
  controls.replaceWith(updatedControls);

  const updatedList = document.createRange().createContextualFragment(res.list);

  if (target.hasAttribute(selectors.paginatedListHide)) {
    list.replaceChildren(updatedList);

    const returnScrollTo = document.querySelector(selectors.paginatedListScrollTo) ?? document.body;
    scrollTo(returnScrollTo);
  } else {
    list.append(updatedList);
  }

  fireEvent("paginatedlist:update", document.documentElement);
};

export default {
  init: () => {
    delegate(selectors.paginatedListTrigger, "click", handleTrigger);
  },
};
